<ul class="nav nav-tabs">
	{{#each tabs}}
	<li class="tab-heading {{#if active}} active {{/if}}"><a href="#{{../IDPrefix}}{{tabID}}" data-toggle="tab" aria-expanded="false">{{tabHeading}}</a></li>
	{{/each}}
</ul>

<div class="row">
	{{#if showGraphic}}
	<div id="js-graphic" class="col-xs-12 col-sm-8">
		<div class="drinking-water-graph-container">
			{{> DRINKING_WATER_GRAPHIC graph_config}}
		</div>
	</div>
	{{/if}}
	<div id="js-parameter-container" class="form-group col-xs-12{{#if showGraphic}} col-sm-4  col-lg-4{{else}} {{#if readMode}}col-lg-8{{else}}col-sm-12{{/if}}{{/if}}">
		<div class="tab-content tab-no-box">
			{{#each tabs}}
			<div id="{{../IDPrefix}}{{tabID}}" class="tab-pane m-t-20 {{#if active}}active{{/if}}">
				{{#if formElements}}
				<div class="subform">
					{{#if toggleOption}}
						<label for="{{toggleOptionID}}" class="subform-label">{{toggleOption}}</label>
						<input id="{{toggleOptionID}}" {{#COMPARE toggleValue '==' 1}} checked="true" {{/COMPARE}}type="checkbox" name="{{toggleOption}}"  class="subform-checkbox{{#if ../this.readMode}} standard-cursor" disabled="disabled" {{else}}"{{/if}}>
					{{/if}}
					{{#each formElements}}
						<label for="{{@key}}-{{@../key}}">{{name}}</label>
						{{#COMPARE @key '==' 'desinfectionDay'}}
						{{#SELECT val}}
						<select {{#unless ../this.readOnly}}id="{{@key}}{{/unless}}-{{@../key}}"
							class="js-parameter-input form-control input-sm{{#if ../../this.readMode}} standard-cursor{{/if}}"
							{{#if ../this.readOnly}}disabled="disabled" {{/if}}>
							{{#each dayNames}}
							<option value="{{CALCULATE @index '+' 1}}">{{this}}</option>
							{{/each}}
						</select>
						{{/SELECT}}
						{{else}}
						<div>
							{{#COMPARE type '==' 'time'}}
							<div class="input-group bootstrap-timepicker timepicker">
								<input
									type="text" {{#if ../this.readOnly}}disabled="disabled" {{/if}}
									class="form-control input-sm {{#if ../../this.readMode}}standard-cursor{{else}}js-timepicker js-time{{/if}}"
									{{#unless ../../this.readMode}}id="{{@key}}-{{@../key}}"{{/unless}}
									value="{{val}}">
								<span class="input-group-addon"><i class="fa fa-clock-o"></i></span>
							</div>
							{{else}}
							<div class="input-group">
								<input
									type="number" {{#if ../this.readOnly}}disabled="disabled" {{/if}}
									class="form-control input-sm {{#if ../../this.readMode}}standard-cursor{{else}}js-parameter-input{{/if}}"
									{{#unless ../../this.readMode}}id="{{@key}}-{{@../key}}"{{/unless}}
									value="{{#COMPARE unit '==' '°C'}}{{CALCULATE val '/' 10}}{{else}}{{val}}{{/COMPARE}}">
								<span class="input-group-addon">{{unit}}</span>
							</div>
							{{/COMPARE}}
						</div>
						{{/COMPARE}}
					{{/each}}
				</div>
				{{/if}}
				<div class="gc-1-1">
				{{#each specialOptions}}
					<div class="subform {{gridPosition}}">
						<label for="{{toggleOptionID}}" class="subform-label">{{toggleOption}}</label>
						<input {{#unless ../../this.readMode}}id="{{toggleOptionID}}{{/unless}}" {{#COMPARE toggleValue '==' 1}} checked="true" {{/COMPARE}}type="checkbox" name="{{toggleOption}}"
						class="subform-checkbox{{#if ../../this.readMode}} standard-cursor" disabled="disabled"{{else}}"{{/if}}>
						{{#each formElements}}
							<label for="{{@key}}">{{name}}</label>
							<div class="input-group">
								<input
									type="number" {{#if ../this.readOnly}}disabled="disabled" {{/if}}
									class="form-control input-sm {{#unless ../this.readOnly}}js-parameter-input{{/unless}}
									{{#if ../../../this.readMode}} standard-cursor{{/if}}"
									{{#unless ../this.readOnly}}id="{{@key}}"{{else}}{{/unless}}
									value="{{#COMPARE unit '==' '°C'}}{{CALCULATE val '/' 10}}{{else}}{{val}}{{/COMPARE}}">
								<span class="input-group-addon">{{unit}}</span>
							</div>
						{{/each}}
					</div>
				{{/each}}
				</div>
			</div>
			{{/each}}
		</div>
	</div>
</div>
